import { render, staticRenderFns } from "./userManagement.vue?vue&type=template&id=1350c818&scoped=true&"
import script from "./userManagement.vue?vue&type=script&lang=ts&"
export * from "./userManagement.vue?vue&type=script&lang=ts&"
import style0 from "./userManagement.vue?vue&type=style&index=0&id=1350c818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1350c818",
  null
  
)

export default component.exports